import { DataGridPro, GRID_CHECKBOX_SELECTION_COL_DEF, gridClasses } from "@mui/x-data-grid-pro";
import { FilterC } from "../../filter/FilterComon";
import { Avatar, Box, Collapse, LinearProgress } from "@mui/material";
import { useCallback, useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { daysBetween } from "../../../utils/Dates";
import { Context } from "./Context";
import { renderCell } from "./RenderCell";
import { getBorder, stringToColor } from "../../../utils/Styles";
import RefreshIcon from "@mui/icons-material/Refresh";
import PunchClockIcon from "@mui/icons-material/PunchClock";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import AllInboxIcon from "@mui/icons-material/AllInbox";
//import SaveIcon from '@mui/icons-material/Save';
import WalletIcon from "@mui/icons-material/Wallet";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import GroupsIcon from "@mui/icons-material/Groups";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { ContextMenu } from "../../context_menu/ContextMenu";
import { AddPaycode } from "../../dialog/schedule/AddPaycode";
import { AddShift } from "../../dialog/schedule/AddShift";
import CleanSchedule from "../../dialog/schedule/CleanSchedule";
import { useNavigate } from "react-router-dom";
import { Table as Audit } from "../audit/Table";
import { LoadShifts } from "../../dialog/schedule/LoadShifts";
import { DeletionConfirmation } from "../../dialog/schedule/DeletionConfirmation";
import moment from "moment";
import { getGridStringOperators, GridColumnMenu } from "@mui/x-data-grid";
import { trackGaClick } from "../../../utils/analytics";

const CustomColumnMenu = (props) => {
	return (
		<>
			<GridColumnMenu
				{...props}
				slots={{
					// Hide `columnMenuColumnsItem`
					columnMenuColumnsItem: null,
				}}
			/>
		</>
	);
};

const Table = () => {
	const { t } = useTranslation('schedule.table');

	const {
		apiRef,
		loadingGettingOpenPeriod,
		loadingGettingSchedule,
		range1,
		rangeColumns,
		rows,
		smartgroup,
		employee,
		reloading,
		deleteOpen,
		setDeleteOpen,
		dataDelete,
		setDataDelete,
		dataPaycodeDay,
		setDataPaycodeDay,
		dataPaycodeHour,
		setDataPaycodeHour,
		type,
		periods,
	} = useContext(Context);

	const navigate = useNavigate();

	const [cell, setCell] = useState({ column: null, row: null });
	const [checked, setChecked] = useState([]);
	const [contextMenu, setContextMenu] = useState(null);
	const [open, setOpen] = useState(false);

	const [addOpenPaycode, setAddOpenPaycode] = useState(false);
	const [addOpenShift, setAddOpenShift] = useState(false);
	const [AddLoadOpen, setAddLoadOpen] = useState(false);
	const [cleanOpen, setCleanOpen] = useState(false);

	const columns = useMemo(
		() => [
			{
				field: "avatar",
				headerName: t("table.columns.avatar"),
				alignHeader: "center",
				width: 60,
				minWidth: 60,
				disableColumnMenu: true,
				sortable: false,
				resizable: false,
				headerAlign: "center",
				filterOperators: getGridStringOperators().filter((operator) => operator.value !== "isAnyOf"),
				renderCell: (params) => {
					return (
						<Box sx={{ pt: 1, pb: 1 }}>
							<Avatar
								sx={{
									bgcolor: stringToColor(params.row.full_name),
								}}
							>
								{params.row.full_name.charAt(0)}
							</Avatar>
						</Box>
					);
				},
			},
			{
				field: "full_name",
				headerName: t("table.columns.full_name"),
				flex: 2,
				minWidth: 250,
				filterOperators: getGridStringOperators().filter((operator) => operator.value !== "isAnyOf"),
			},
			{
				field: "person_number",
				headerName: t("table.columns.person_number"),
				flex: 0.5,
				minWidth: 200,
				filterOperators: getGridStringOperators().filter((operator) => operator.value !== "isAnyOf"),
			},
			...daysBetween(rangeColumns[0], rangeColumns[1]).map((day) => ({
				field: day,
				headerName: `${moment(day, "YYYY-MM-DD")
					.format("ddd DD/MM/YYYY")
					.charAt(0)
					.toUpperCase()}${moment(day, "YYYY-MM-DD").format("ddd DD/MM/YYYY").slice(1)}`,
				flex: 1,
				minWidth: 200,
				disableColumnMenu: true,
				sortable: false,
				headerAlign: "center",
				renderCell,
			})),
			{
				field: "planned_hours",
				headerName: t("table.columns.planned_hours"),
				headerAlign: "center",
				align: "center",
				minWidth: 150,
				width: 150,
			},
		],
		[t, rangeColumns],
	);

	const options = useMemo(
		() => [
			{
				privilege:
					JSON.parse(sessionStorage.getItem("privileges")).schedule
						.get_paycodes &&
					JSON.parse(sessionStorage.getItem("privileges")).schedule
						.add_paycode_hours,
				name: t("table.menu.add_paycode"),
				click: () => {
					trackGaClick({
						id: "schedule.open_add_paycode",
						gaAction: "open_add_paycode",
						gaType: "schedule",
					});
					setAddOpenPaycode(true);
					setContextMenu(null);

					// console.log(
					// 	"data",
					// 	rows.map((row) => ({
					// 		id: row.id,
					// 		name: row.full_name,
					// 	})),
					// 	"open",
					// 	addOpenPaycode,
					// 	"checked",
					// 	rows
					// 		.filter((row) => checked.includes(row.id))
					// 		.map((row) => ({
					// 			id: row.id,
					// 			name: row.full_name,
					// 		})),
					// 	"cell",
					// 	cell,
					// 	"action",
					// 	"schedule",
					// );
				},
				icon: <WalletIcon />,
				group: 1,
				disabled: false,
				seleted: false,
				onlyOne: false,
				dialog: (
					<AddPaycode
						data={rows.map((row) => ({
							id: row.id,
							name: row.full_name,
						}))}
						open={addOpenPaycode}
						setOpen={setAddOpenPaycode}
						checked={rows
							.filter((row) => checked.includes(row.id))
							.map((row) => ({
								id: row.id,
								name: row.full_name,
							}))}
						cell={cell}
						setCell={setCell}
						action={"schedule"}
						reloading={reloading}
					/>
				),
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.schedule.add_shift,
				name: t("table.menu.add_shift"),
				click: () => {
					trackGaClick({
						id: "schedule.open_add_shift",
						gaAction: "open_add_shift",
						gaType: "schedule",
					});
					setAddOpenShift(true);
					setContextMenu(null);
				},
				icon: <WorkHistoryIcon />,
				group: 1,
				disabled: false,
				seleted: false,
				onlyOne: false,
				dialog: (
					<AddShift
						data={rows.map((row) => ({
							id: row.id,
							name: row.full_name,
						}))}
						open={addOpenShift}
						setOpen={setAddOpenShift}
						checked={rows
							.filter((row) => checked.includes(row.id))
							.map((row) => ({
								id: row.id,
								name: row.full_name,
							}))}
						cell={cell}
						setCell={setCell}
						reloading={reloading}
					/>
				),
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.schedule.add_shift,
				name: t("table.menu.load_shifts"),
				click: () => {
					setAddLoadOpen(true);
					setContextMenu(null);
				},
				icon: <WorkHistoryIcon />,
				group: 1,
				disabled: false,
				seleted: false,
				onlyOne: false,
				dialog: <LoadShifts open={AddLoadOpen} setOpen={setAddLoadOpen} reloading={reloading} />,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.schedule.clean_schedule,
				name: t("table.menu.clean_row"),
				click: () => {
					trackGaClick({
						id: "schedule.open_clean_schedule",
						gaAction: "open_clean_schedule",
						gaType: "schedule",
					});
					setCleanOpen(true);
					setContextMenu(null);
				},
				icon: <CleaningServicesIcon />,
				group: 1,
				disabled: false,
				seleted: false,
				onlyOne: false,
				dialog: (
					<CleanSchedule
						data={rows.map((row) => ({
							id: row.id,
							name: row.full_name,
						}))}
						open={cleanOpen}
						setOpen={setCleanOpen}
						checked={rows
							.filter((row) => checked.includes(row.id))
							.map((row) => ({
								id: row.id,
								name: row.full_name,
							}))}
						cell={cell}
						setCell={setCell}
						reloading={reloading}
					/>
				),
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.employees.show_page,
				name: t("table.menu.go_to_employees"),
				click: () => {
					// em: {id, full_name, smarthgroup}
					// sg: {id, name}
					sessionStorage.setItem(
						"employees",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("employees"))?.environment
								? JSON.parse(sessionStorage.getItem("employees")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: employee.filter((e) => checked.includes(e.id)).map((e) => e),
							},
						}),
					);

					navigate("/employees");
				},
				icon: <GroupsIcon />,
				group: 2,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.timecard.show_page,
				name: t("table.menu.go_to_timecard"),
				click: () => {
					sessionStorage.setItem(
						"timecard",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("timecard"))?.environment
								? JSON.parse(sessionStorage.getItem("timecard")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: [employee.filter((e) => checked.includes(e.id)).map((e) => e)[0]],
							},
						}),
					);

					navigate("/timecard");
				},
				icon: <PunchClockIcon />,
				group: 2,
				disabled: checked.length !== 1,
				seleted: false,
				onlyOne: true,
				dialog: undefined,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.overtime.show_page,
				name: t("table.menu.go_to_overtime"),
				click: () => {
					// em: {id, full_name, smarthgroup}
					// sg: {id, name}
					sessionStorage.setItem(
						"overtime",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("overtime"))?.environment
								? JSON.parse(sessionStorage.getItem("overtime")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: employee.filter((e) => checked.includes(e.id)).map((e) => e),
							},
						}),
					);

					navigate("/overtime");
				},
				icon: <MoreTimeIcon />,
				group: 2,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges"))
					.requests.show_page,
				name: t("table.menu.go_to_requests"),
				click: () => {
					// em: {id, full_name, smarthgroup}
					// sg: {id, name}
					sessionStorage.setItem(
						"requests",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("requests"))?.environment
								? JSON.parse(sessionStorage.getItem("requests")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: employee.filter((e) => checked.includes(e.id)).map((e) => e),
							},
						}),
					);

					navigate("/requests");
				},
				icon: <AllInboxIcon />,
				group: 2,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: true,
				name: t(
					open
						? "table.menu.close_audit"
						: "table.menu.open_audit"
				),
				click: () => {
					trackGaClick({
						id: "schedule.open_audit",
						gaAction: "open_audit",
						gaType: open ? "close" : "open",
					});
					setContextMenu(null);
					setOpen(!open);
				},
				icon: <PendingActionsIcon />,
				group: 3,
				disabled: false,
				seleted: false,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: true,
				name: t("table.menu.reload"),
				click: () => {
					setContextMenu(null);
					reloading();
				},
				icon: <RefreshIcon />,
				group: 4,
				disabled: JSON.parse(sessionStorage.getItem("schedule"))?.reloading ? false : true,
				seleted: false,
				onlyOne: false,
			},
		],
		[
			t,
			rows,
			addOpenPaycode,
			cell,
			reloading,
			addOpenShift,
			AddLoadOpen,
			cleanOpen,
			checked,
			open,
			range1,
			smartgroup,
			employee,
			navigate,
		],
	);

	return (
		<Box
			sx={{
				[`.${gridClasses.cell}.open`]: {
					backgroundColor: (theme) => theme.palette.background.default,
				},
				[`.${gridClasses.cell}.close`]: {
					backgroundColor: (theme) => theme.palette.background.close,
				},
			}}
		>
			<div
				onContextMenu={(event) => {
					event.preventDefault();

					if (addOpenShift || addOpenPaycode || cleanOpen || AddLoadOpen) {
						return;
					}

					setContextMenu(
						contextMenu === null
							? {
									mouseX: event.clientX + 2,
									mouseY: event.clientY - 6,
							  }
							: null,
					);
				}}
			>
				<DataGridPro
					apiRef={apiRef}
					showCellVerticalBorder
					showColumnVerticalBorder
					//unstable_headerFilters
					checkboxSelection
					loading={loadingGettingSchedule || loadingGettingOpenPeriod}
					columns={columns}
					rows={rows}
					slots={{
						toolbar: useCallback(() => <FilterC view={"schedule"} />, []),
						loadingOverlay: LinearProgress,
						columnMenu: CustomColumnMenu,
					}}
					slotProps={{
						row: {
							onContextMenu: (e) => {
								if (e?.target?.dataset?.field) {
									setCell({
										column: e?.target?.dataset?.field,
										row: e?.currentTarget?.getAttribute("data-id"),
									});
								} else {
									const date = e?.target?.id.match(/\d{4}-\d{2}-\d{2}/);

									setCell({
										column: date ? date[0] : null,
										row: e?.currentTarget?.getAttribute("data-id"),
									});
								}
							},
						},
					}}
					rowSelectionModel={checked}
					onRowSelectionModelChange={(newRowSelectionModel) => {
						setChecked(newRowSelectionModel);
					}}
					sx={{
						height: `calc(100vh - ${open ? "55vh" : "120px"})`,
					}}
					getRowHeight={(params) => {
						const { model } = params;

						let length = 64;

						for (const key in model) {
							let counter = 0;

							if (model[key].shifts) {
								counter = counter + model[key].shifts.length * 47;
							}

							if (model[key].hours) {
								counter = counter + model[key].hours.length * 47;
							}

							if (model[key].days) {
								counter = counter + model[key].days.length * 47;
							}

							if (counter > length) {
								length = counter;
							}
						}

						return length;
					}}
					pinnedColumns={{
						left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, "avatar", "full_name", "person_number"],
					}}
					getCellClassName={(params) => {
						if (!moment(params?.field, "YYYY-MM-DD").isValid()) {
							const end_date = periods.find(
								(period) => period?.person_number === params?.row?.person_number,
							)?.end_date;

							if (moment(end_date, "YYYY-MM-DD").isValid()) {
								if (moment(end_date, "YYYY-MM-DD").isBefore(rangeColumns[1], "YYYY-MM-DD")) {
									return "open";
								} else {
									return "close";
								}
							} else {
								return "open";
							}
						}

						const style = moment(
							periods.find((period) => period.person_number === params?.id)?.end_date,
							"YYYY-MM-DD",
						).isSameOrAfter(moment(params?.field, "YYYY-MM-DD"));

						return style ? "close" : "open";
					}}
					isRowSelectable={(params) => {
						const end_date = periods.find(
							(period) => period?.person_number === params?.row?.person_number,
						)?.end_date;
						return moment(end_date, "YYYY-MM-DD").isBefore(rangeColumns[1], "YYYY-MM-DD");
					}}
					hideFooter
					disableRowSelectionOnClick
					columnBuffer={5}
					rowBuffer={5}
				/>

				<ContextMenu
					contextMenu={contextMenu}
					setContextMenu={setContextMenu}
					options={options}
					checked={checked}
				/>

				<DeletionConfirmation
					open={deleteOpen}
					setOpen={setDeleteOpen}
					type={type}
					dataDelete={dataDelete}
					setDataDelete={setDataDelete}
					dataPaycodeDay={dataPaycodeDay}
					setDataPaycodeDay={setDataPaycodeDay}
					dataPaycodeHour={dataPaycodeHour}
					setDataPaycodeHour={setDataPaycodeHour}
					reloading={reloading}
				/>
			</div>

			<Collapse
				sx={{
					height: "55vh",
					mt: 2.5,
					ml: -2.5,
					mr: -2.5,
					p: 2.5,
					borderTop: (theme) => getBorder(theme.palette.mode),
				}}
				in={open}
				timeout="auto"
				unmountOnExit
			>
				<Audit open={open} setOpen={setOpen} view={"schedule"} />
			</Collapse>
		</Box>
	);
};

export { Table };
